import type { DashboardRole } from './resolve';

const KEY = 'toscana.dashPreview';

function load(): DashboardRole | null {
  try {
    const v = sessionStorage.getItem(KEY);
    if (v) return v as DashboardRole;
  } catch { /* ignore */ }
  return null;
}

/** Estado reactivo compartido — usar .role en componentes Svelte. */
let _preview = $state<DashboardRole | null>(load());

export const dashboardPreview = {
  get role(): DashboardRole | null { return _preview; },
  set role(v: DashboardRole | null) {
    _preview = v;
    try {
      if (v) sessionStorage.setItem(KEY, v);
      else sessionStorage.removeItem(KEY);
    } catch { /* ignore */ }
  },
};

/** @deprecated usar dashboardPreview.role */
export function previewRole(): DashboardRole | null {
  return _preview;
}

export function setPreviewRole(r: DashboardRole | null): void {
  dashboardPreview.role = r;
}
